import { toast } from "react-toastify";
import { COMMON, TASK_GROUP_SETTINGS } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const fetchTaskGroupSettingsTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(TASK_GROUP_SETTINGS.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitTaskGroupSettingsFilterData = async (data = {}) => {
  try {
    const response = await POST(TASK_GROUP_SETTINGS.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateTaskGroupSettings = async (groupId, data = {}) => {
  try {
    const response = await PUT(TASK_GROUP_SETTINGS.BY_GROUP_ID(groupId), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/task-bucket-group` */
export const getCommonTaskBucketGroupOptions = async () => {
  try {
    const response = await GET(COMMON.TASK_BUCKET_GROUP);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
